// selects the contents of the dom node and copies them,
// and creates an email with subject and link in body
import config from '../config/config';
import { getViewPdfLink } from '.';

export default function copyAndSendPreview(node, pdf) {
  console.log(pdf);
  console.log(node);
  // previously we were rendering a richpdf preview
  // and copying it to the clipboard
  // decided not enough email clients
  // will support direct html parsing 😞

  // window.getSelection().selectAllChildren(node);
  // document.execCommand("copy");

  const link = pdf.shortLink
    ? `${config.shortLinkDomain}${pdf.shortLink}`
    : getViewPdfLink(pdf.pdfType, pdf.slug);
  const title = `${pdf.edition} ${pdf.publication} ${pdf.monthPublished} ${pdf.yearPublished}`;
  window.location = `mailto:?subject=${title}&body=${title}%0D%0A%0D%0AView: ${link}%0D%0A%0D%0A`;
}
